import React from 'react';
import Layout from './layout';

const Privacy = () => (
    <Layout selected="privacy">
        <div className="container min-vh-100 legal-page">
            <h1>Privacy Policy</h1>
            <p className="text-muted">Last updated: May 1, 2026</p>

            <p>
                Torgyd helps people create and listen to location-based audio tours.
                This Privacy Policy explains what information we collect, how we use it,
                and the choices you have. We do not sell your personal information.
            </p>

            <h2>Information We Collect</h2>
            <p>We may collect the following information when you use Torgyd:</p>
            <ul>
                <li>Account information, such as your name, email address, username, and sign-in details.</li>
                <li>Profile information you choose to provide as a tour guide, such as bio, avatar, website, social links, guide location, map pin color, and map pin emoji.</li>
                <li>Tour and content information, including tour titles, descriptions, audio files, text content, comments, ratings, and GPS locations for tour stops.</li>
                <li>Location information, if you allow location access, so we can show nearby tours, center the map, and help you create stops at the right place.</li>
                <li>Basic technical information, such as IP address, browser or device type, app version, logs, and diagnostics needed to operate and secure the service.</li>
            </ul>

            <h2>How We Use Information</h2>
            <p>We use information to:</p>
            <ul>
                <li>Provide, maintain, and improve Torgyd.</li>
                <li>Create and display tours, map pins, audio stops, comments, and guide profiles.</li>
                <li>Authenticate users and protect accounts.</li>
                <li>Show nearby tours and location-based content.</li>
                <li>Respond to support requests and enforce our policies.</li>
                <li>Monitor performance, fix bugs, and keep the service secure.</li>
            </ul>

            <h2>Public Content</h2>
            <p>
                Tours, tour stops, guide profiles, map pins, comments, and related content
                may be visible to other users depending on the tour privacy setting and how
                you publish or share that content. Do not publish information you do not want
                others to see.
            </p>

            <h2>Sharing Information</h2>
            <p>
                We do not sell your personal information. We may share information with service
                providers who help us operate Torgyd, such as hosting, storage, authentication,
                email, maps, analytics, or security providers. These providers may only use the
                information to provide services to us and must protect it appropriately.
            </p>
            <p>
                We may also disclose information if required by law, to protect rights and safety,
                to prevent abuse, or as part of a merger, acquisition, financing, or sale of assets.
            </p>

            <h2>Location Data</h2>
            <p>
                Torgyd uses location to show nearby tours and help creators place stops on a map.
                You can control location permissions through your browser or device settings.
                Tour stop locations that you publish may remain visible as part of the tour until
                you edit or delete the content.
            </p>

            <h2>Data Retention and Deletion</h2>
            <p>
                We keep information for as long as needed to provide the service, comply with legal
                obligations, resolve disputes, and enforce agreements. You may request account or
                content deletion by contacting us. Some information may remain in backups, logs, or
                records where retention is necessary for security, legal compliance, or legitimate
                business purposes.
            </p>

            <h2>Your Choices</h2>
            <ul>
                <li>You can update your account, guide profile, tours, and stops in the app or website.</li>
                <li>You can change or revoke location permissions in your browser or device settings.</li>
                <li>You can request access, correction, or deletion of your information by contacting us.</li>
                <li>You can stop using Torgyd at any time.</li>
            </ul>

            <h2>Children</h2>
            <p>
                Torgyd is not directed to children under 13, and we do not knowingly collect personal
                information from children under 13. If you believe a child has provided personal
                information to us, please contact us so we can take appropriate action.
            </p>

            <h2>Security</h2>
            <p>
                We use reasonable administrative, technical, and organizational safeguards to protect
                information. No method of transmission or storage is completely secure, so we cannot
                guarantee absolute security.
            </p>

            <h2>Changes to This Policy</h2>
            <p>
                We may update this Privacy Policy from time to time. If we make material changes, we
                will update the date above and provide notice when appropriate.
            </p>

            <h2>Contact Us</h2>
            <p>
                If you have questions or requests about this Privacy Policy or your information,
                contact us at <a href="mailto:admin@castlerock.ai">admin@castlerock.ai</a>.
            </p>
        </div>
    </Layout>
);

export default Privacy;
